import { apiClient } from "@/lib/api-client"
import {
  AssignResourceAccessRequest,
  MyResourceAccessDto,
  PagedResult,
  ResourceAssigneesByResourceDto,
  ResourceAssignmentAuditDto,
  ResourceAssignmentDto,
  ResourceType,
} from "../dtos/ResourceAccessDtos"

export const resourceAccessService = {
  getAssignments: async (
    organizationId: string,
    type: ResourceType,
    resourceId: string,
  ): Promise<ResourceAssignmentDto[]> => {
    const response = await apiClient.get<ResourceAssignmentDto[]>(
      `/organizations/${organizationId}/resource-access/${type}/${resourceId}`,
    )
    return response.data
  },

  getMyAccess: async (
    organizationId: string,
    type: ResourceType,
    resourceId: string,
  ): Promise<MyResourceAccessDto> => {
    const response = await apiClient.get<MyResourceAccessDto>(
      `/organizations/${organizationId}/resource-access/${type}/${resourceId}/me`,
    )
    return response.data
  },

  getAssigneesForList: async (
    organizationId: string,
    type: ResourceType,
  ): Promise<ResourceAssigneesByResourceDto[]> => {
    const response = await apiClient.get<ResourceAssigneesByResourceDto[]>(
      `/organizations/${organizationId}/resource-access/${type}`,
    )
    return response.data
  },

  assign: async (
    organizationId: string,
    type: ResourceType,
    resourceId: string,
    userId: string,
    request: AssignResourceAccessRequest,
  ): Promise<ResourceAssignmentDto> => {
    const response = await apiClient.put<ResourceAssignmentDto>(
      `/organizations/${organizationId}/resource-access/${type}/${resourceId}/assignees/${userId}`,
      request,
    )
    return response.data
  },

  revoke: async (
    organizationId: string,
    type: ResourceType,
    resourceId: string,
    userId: string,
  ): Promise<void> => {
    await apiClient.delete(
      `/organizations/${organizationId}/resource-access/${type}/${resourceId}/assignees/${userId}`,
    )
  },

  getAuditLog: async (
    organizationId: string,
    params: { type?: ResourceType; resourceId?: string; page?: number; pageSize?: number } = {},
  ): Promise<PagedResult<ResourceAssignmentAuditDto>> => {
    const response = await apiClient.get<PagedResult<ResourceAssignmentAuditDto>>(
      `/organizations/${organizationId}/resource-access/audit-log`,
      { params },
    )
    return response.data
  },
}
